<template>
    <el-dropdown class="cursor-pointer" trigger="click" popper-class="custom-dropdown" placement="bottom"
        @visible-change="handleChange">
        <!-- <img
            src="@/assets/svgs/translate.svg"
            alt="translate"
            :class="[getCurrentLocale === LocaleTypeEnum.English ? 'w-20' : 'w-24', isWhite ? '!color-#ffffff' : '!color-#2C364B']"
        /> -->
        <icon-svg-translate size="1.25rem" class="w-22 h-22" :class="[isWhite ? '!color-#ffffff' : '!color-#2C364B']" />
        <template #dropdown>
            <el-dropdown-menu>
                <el-dropdown-item v-for="locale in getLocaleOption" :key="locale.value"
                    :class="{ 'is-active': locale.value === getCurrentLocale }" @click="changeLanguage(locale.value)">
                    <span :class="{ 'color-primary': locale.value === getCurrentLocale }">
                        {{ locale.label }}
                    </span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>
<script setup lang="tsx">
import { useLocale } from '@/hooks/useLocale';
import { LANG_MAP, LOCALE_TO_LANG } from '@/router';
import { LocaleTypeEnum } from '@/store/locale';
const { getCurrentLocale, setCurrentLocale, getLocaleOption } = useStore('locale');
const { changeLocale } = useLocale();
const active = ref(false);
const router = useRouter();
const route = useRoute();
const handleChange = (val: boolean) => {
    active.value = val;
};
const props = defineProps({
    isWhiteTheme: {
        type: Boolean,
        default: false,
    },
});
const isWhite = computed(() => props.isWhiteTheme);

const changeLanguage = (locale: LocaleTypeEnum) => {
    if (locale === getCurrentLocale.value) {
        return;
    }
    setCurrentLocale(locale);
    changeLocale(locale);
    // 更新路由中的 lang 参数
    const newLang = LOCALE_TO_LANG[locale as LocaleTypeEnum];
    router.replace({
        query: { ...route.query, lang: newLang },
    });
};

watch(
    () => route.query.lang as string,
    (lang: string) => {
        if (lang) {
            const targetLocale = LANG_MAP[lang as keyof typeof LANG_MAP] ?? LocaleTypeEnum.Chinese;
            changeLanguage(targetLocale);
        }
    },
    {
        immediate: true,
    }
);
</script>
<style scoped lang="scss"></style>
